/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getPCInfos = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 PC Info query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-pc-info/get?${queryString}`);
};

export const getPCInfoByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-pc-info/${id}`);
};

export const getPCInfoBySN = (sn) => {
  return API.get(`${getApiUrl()}/api/tkt1-pc-info/sn/${sn}`);
};

export const createPCInfo = (pcInfoData) => {
  return API.post(`${getApiUrl()}/api/tkt1-pc-info/`, pcInfoData);
};

export const updatePCInfo = (id, pcInfoData) => {
  return API.put(`${getApiUrl()}/api/tkt1-pc-info/update/${id}`, pcInfoData);
};

export const updatePCInfoBySN = (sn, pcInfoData) => {
  return API.put(`${getApiUrl()}/api/tkt1-pc-info/sn/${sn}`, pcInfoData);
};

export const deletePCInfo = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-pc-info/${id}`);
};

export const tkt1PCInfoService = {
  getPCInfos,
  getPCInfoByID,
  getPCInfoBySN,
  createPCInfo,
  updatePCInfo,
  updatePCInfoBySN,
  deletePCInfo
};
